import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { green, red, orange } from "@mui/material/colors";
import ReportProblemTwoToneIcon from '@mui/icons-material/ReportProblemTwoTone';
import CheckCircleTwoToneIcon from '@mui/icons-material/CheckCircleTwoTone';
import ErrorTwoToneIcon from '@mui/icons-material/ErrorTwoTone';
import { Box, Grid, LinearProgress, Typography } from "@mui/material";
const MIN = 0
const MEAN = 3;
const MAX = 35;

const LinearProgressTotDaysStats = (props) => {
  const { title, days = 0, xs = 12, sm = 7, legalDayLimit } = props;
  const { t } = useTranslation();
  return (
    <Grid
      item
      xs={xs}
      sm={sm}
      container
      display="flex"
      alignItems="center"
      justifyContent="center"
      spacing={1}
    >
      {(
        <Fragment>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center" justifyContent="center">
              <Typography align="center" variant="h6" color="white">
                {t(title)}
              </Typography>

              {legalDayLimit !== undefined && legalDayLimit !== null && (
                <Fragment>
                  {legalDayLimit === 2 ? (
                    <ErrorTwoToneIcon
                      style={{
                        color: red[500],
                        width: 18,
                        height: 18,
                        marginLeft: 5,
                      }}
                    />
                  ) : legalDayLimit === 1 ? (
                    <ReportProblemTwoToneIcon
                      style={{
                        color: orange[500],
                        width: 40,
                        height: 40,
                        zIndex: 20,
                      }}
                    />
                  ) : (
                    <CheckCircleTwoToneIcon
                      style={{
                        color: green[500],
                        width: 18,
                        height: 18,
                        marginLeft: 5,
                      }}
                    />
                  )}
                </Fragment>
              )}
            </Box>
          </Grid>
          {days !== null ?
            <Grid
              item
              container
              xs={12}
              display="flex"
              justifyContent="space-between"
            >
              <Grid
                item
                container
                xs={8}
                mt={0.5}
                ml={1}
                display="flex"
                alignItems="center"
                justifyContent='center'
              >
                <Grid item xs={12}>
                  <LinearProgress
                    variant="determinate"
                    value={(days * 100) / MAX}
                    sx={{
                      backgroundColor: "#fff",
                      "& .MuiLinearProgress-bar1Determinate": {
                        backgroundColor: `${green[500]}B3`,
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box display="flex" justifyContent="space-between">
                    <Box display="flex" sx={{ marginLeft: "-4%" }}>
                      <Typography sx={{ fontSize: 10, opacity: 0.9 }}>
                        {MIN}
                      </Typography>
                      <Typography sx={{ fontSize: 10, marginLeft: 0.3 }}>
                        {MEAN}
                      </Typography>
                    </Box>


                    <Typography sx={{ fontSize: 10, marginRight: '-3%' }}>{MAX}</Typography>
                  </Box>

                  <Box display="flex" justifyContent="space-between">
                    <Typography sx={{ fontSize: 10, marginLeft: "-15%" }}>
                      {t("OMS threshold")}
                    </Typography>

                    <Typography sx={{ fontSize: 10, marginRight: "-15%" }}>
                      {t("Legal limit")}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
              <Grid
                item
                xs={3}
                mt={-0.5}

              >
                <Typography align="center" sx={{ fontSize: 10 }}>
                  {`${days} / ${MAX}`}
                </Typography>
                <Typography
                  align="center"
                  sx={{
                    fontSize: 10,
                    lineHeight: 0.8,
                    textTransform: "lowercase",
                  }}
                >
                  {t("Days")}
                </Typography>
              </Grid>
            </Grid>
            : <Grid item xs={12} mt={0.7}>
              <Typography align='center' variant="h6" sx={{  color: "white", opacity: 0.9 }} >
                {t("Data not available")}
              </Typography>
            </Grid>
          }
        </Fragment>
      )
      }
    </Grid >
  );
};

export default LinearProgressTotDaysStats;
